const updates = [
  {
    date: '2026.07.31',
    title: '庆余年第二季大结局上线',
    desc: '范闲最终抉择揭晓，全集已更新完毕，一口气追完不等待。',
  },
  {
    date: '2026.07.30',
    title: '与凤行VIP大结局提前解锁',
    desc: '赵丽颖林更新三界虐恋终章，全集高清已同步上线。',
  },
  {
    date: '2026.07.29',
    title: '暑期档热门电影专题上线',
    desc: '飞驰人生2、第二十条等院线新片高清版已加入片库。',
  },
  {
    date: '2026.07.28',
    title: '播放线路全面升级',
    desc: '新增多条高速播放线路，高峰期观影更流畅，缓冲问题大幅改善。',
  },
  {
    date: '2026.07.27',
    title: '墨雨云间加更两集',
    desc: '本周更新节奏加快，吴谨言复仇剧情迎来关键转折。',
  },
  {
    date: '2026.07.26',
    title: '手机端观影体验优化',
    desc: '移动端界面全面升级，适配刘海屏与折叠屏，手势操作更便捷。',
  },
  {
    date: '2026.07.25',
    title: '韩剧专区新增多部高分剧',
    desc: '黑暗荣耀第二季、恶鬼等口碑韩剧全集已上线，中文字幕同步更新。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500">丫丫影院每日更新动态与上架快讯</p>
        </div>

        <div className="relative">
          <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-5 pl-12">
                <div className={`absolute left-3.5 w-3 h-3 rounded-full border-2 mt-1.5 ${
                  idx === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-primary-300'
                }`}></div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                  <h3 className="text-sm font-medium text-foreground-900 mt-1">{item.title}</h3>
                  <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}